import React from "react";

const OutputWindow = ({ outputDetails }) => {
    const getOutput = () => {
        let statusId = outputDetails?.status?.id;

        if (statusId === 6) {
            return (
                <pre className="px-3 py-2 font-normal text-sm text-red-400">
                    {atob(outputDetails?.compile_output)}
                </pre>
            );
        } else if (statusId === 3) {
            return (
                <pre className="px-3 py-2 font-normal text-sm text-green-400">
                    {atob(outputDetails.stdout) !== null
                        ? `${atob(outputDetails.stdout)}`
                        : null}
                </pre>
            );
        } else if (statusId === 5) {
            return (
                <pre className="px-3 py-2 font-normal text-sm text-yellow-400">
                    {`Time Limit Exceeded`}
                </pre>
            );
        } else {
            return (
                <pre className="px-3 py-2 font-normal text-sm text-red-400">
                    {atob(outputDetails?.stderr)}
                </pre>
            );
        }
    };
    return (
        <>
            <div className="px-3 py-2 border-b border-gray-700/30">
                <h1 className="font-medium text-sm text-gray-300">
                    Output
                </h1>
            </div>
            <div className="w-full h-56 bg-[#131723] text-gray-200 font-mono text-sm overflow-y-auto">
                {outputDetails ? <>{getOutput()}</> : (
                    <div className="px-3 py-2 text-gray-500 italic">
                        Run your code to see output here...
                    </div>
                )}
            </div>
        </>
    );
};

export default OutputWindow;